import * as React from "react";
const SvgFiRrSyringe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-syringe_svg__a)">
      <path
        fill="#062147"
        d="m23.707 5.293-5-5a1 1 0 0 0-1.414 1.414L19.086 3.5 17.6 4.983a5 5 0 0 0-6.481.481l-6.07 6.072A6.95 6.95 0 0 0 3 16.486v3.1L.294 22.292a1 1 0 1 0 1.414 1.414L4.414 21h3.1a6.96 6.96 0 0 0 4.949-2.05l6.072-6.072a4.99 4.99 0 0 0 .482-6.478L20.5 4.914l1.793 1.793a1 1 0 0 0 1.414-1.414m-6.585 6.171-6.072 6.072A4.97 4.97 0 0 1 7.515 19H5v-2.515q0-.492.095-.976l1.2 1.2a1 1 0 1 0 1.414-1.414l-1.741-1.74q.225-.32.5-.6l1.032-1.04 1.793 1.792a1 1 0 0 0 1.414-1.414L8.914 10.5 10.5 8.914l1.793 1.793a1 1 0 0 0 1.414-1.414L11.914 7.5l.622-.622a3.073 3.073 0 0 1 4.242 0l.344.344a3 3 0 0 1 0 4.242"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-syringe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSyringe;
